import { StyleSheet } from 'react-native';

export const detailsStyles = StyleSheet.create({
  detailWrapper: {
    backgroundColor: 'white',
    padding: 6,
    borderRadius: 10,
    marginHorizontal: 11,
    position: 'relative',
  },

  dPic: {
    height: 240,
    width: '100%',
    resizeMode: 'cover',
    borderRadius: 10,
    backgroundColor: '#808080',
    marginTop: 10,
  },
  desc: {
    marginTop: 10,
    // marginaleft: 3,
    color: 'grey',
  },
  brand: {
    fontWeight: 'bold',
    fontSize: 18,
    marginTop: 10,
  },
  price: {
    color: 'black',
    fontWeight: 'bold',
    fontSize: 18,

    marginTop: 10,
    marginRight: 6,
  },
  topIcon: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 8,
  },

  back: {
    color: 'orange',
    fontSize: 28,
  },

  backCircle: {
    color: 'orange',
    width: 28,
    height: 28,
    borderRadius: '50%',
    position: 'absolute',
  },

  heart: {
    color: 'orange',
    fontSize: 20,
    top: 10,
    
  },

  circle: {
    top: 20,
    right: 13,
    backgroundColor: 'white',
   opacity: 0.6,
    width: 28,
    height: 28,
    borderRadius: '50%',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 5,
    

  },

  starWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 8,
  },
  rate: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  star: {
    fontSize: 18,
    color: 'orange',
    marginRight: 5,
  },
});
